import { makeStyles } from '@mui/styles'

const fakeDashedBorder = {
  height: 1,
  border: 'none',
  backgroundSize: '8px 1px, 100% 1px',
}

const useStyles = makeStyles(theme => ({
  trackingLine: {
    flex: 1,
    padding: theme.spacing(2, 0, 3),
  },
  iconWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: theme.spacing(3),
    marginBottom: theme.spacing(1.25),
  },
  isShippingDetailInfoWrapper: {
    textAlign: 'left',
    marginLeft: `calc(50% - ${theme.spacing(1.25)})`,
    width: '100%',
  },
  label: {
    display: 'block',
  },
  description: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: theme.spacing(1.5),
    padding: theme.spacing(0.375, 1),
    backgroundColor: theme.palette.error.light,
    color: theme.palette.primary.dark,
    borderRadius: theme.spacing(2),
    maxWidth: 122,
  },
  descriptionSolved: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: theme.spacing(1.5),
    padding: theme.spacing(0.375, 1),
    backgroundColor: theme.palette.orange.lightest,
    color: theme.palette.orange.darkest,
    borderRadius: theme.spacing(2),
    maxWidth: 122,
  },
  descriptionUnscheduled: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: theme.spacing(1.5),
    padding: theme.spacing(0.375, 1),
    backgroundColor: theme.palette.yellow.lighter,
    color: theme.palette.yellow.darkest,
    borderRadius: theme.spacing(2),
    maxWidth: 122,
  },
  resolved: {
    display: 'inline-flex',
    padding: theme.spacing(0.375, 0.1, 0.375, 0.1),
    color: theme.palette.turquoise.darkest,
  },
  button: {
    ...theme.typography.body2,
    padding: theme.spacing(0.5, 1),
    marginTop: theme.spacing(1.5),
    zIndex: 1,
  },
  buttonReturnedBox: {
    flex:1,
  },
  row: {
    display:'flex',
    flex:1,
  },
  disabled: {
    '& .MuiTypography-h4': {
      color: theme.palette.neutral.light,
    },
  },
  current: {
    '& .MuiTypography-h4': {
      color: theme.palette.turquoise.darkest,
    },
    '&.next-status_disabled': {
      '& .MuiStepConnector-line': {
        ...fakeDashedBorder,
        backgroundImage: `linear-gradient(90deg, transparent, transparent 50%, #fff 50%, #fff 100%),
        linear-gradient(90deg, ${theme.palette.neutral.lighter}, ${theme.palette.neutral.lighter})`,
      },
    },
  },
  resolvedState: {
    '& .MuiTypography-h4': {
      color: theme.palette.orange.darkest,
    },
    '&.next-status_disabled': {
      '& .MuiStepConnector-line': {
        ...fakeDashedBorder,
        backgroundImage: `linear-gradient(90deg, transparent, transparent 50%, #fff 50%, #fff 100%),
        linear-gradient(90deg, ${theme.palette.neutral.lighter}, ${theme.palette.neutral.lighter})`,
      },
    },
  },
  unscheduledState: {
    '& .MuiTypography-h4': {
      color: theme.palette.yellow.darkest,
    },
    '&.next-status_disabled': {
      '& .MuiStepConnector-line': {
        ...fakeDashedBorder,
        backgroundImage: `linear-gradient(90deg, transparent, transparent 50%, #fff 50%, #fff 100%),
        linear-gradient(90deg, ${theme.palette.neutral.lighter}, ${theme.palette.neutral.lighter})`,
      },
    },
  },
  past: {
    '& .MuiTypography-h4': {
      color: theme.palette.green.darkest,
    },
    '& .MuiStepConnector-line': {
      borderColor: theme.palette.green.dark,
    },
    '&.next-status_active': {
      '& .MuiStepConnector-line': {
        ...fakeDashedBorder,
        backgroundImage: `linear-gradient(90deg, transparent, transparent 50%, #fff 50%, #fff 100%),
        linear-gradient(90deg, ${theme.palette.green.dark}, ${theme.palette.turquoise.dark})`,
      },
    },
    '&.next-status_error': {
      '& .MuiStepConnector-line': {
        ...fakeDashedBorder,
        backgroundImage: `linear-gradient(90deg, transparent, transparent 50%, #fff 50%, #fff 100%),
        linear-gradient(90deg, ${theme.palette.green.dark}, ${theme.palette.error.dark})`,
      },
    },
  },
  error: {
    '& .MuiTypography-h4': {
      color: theme.palette.primary.dark,
    },
    '&.next-status_disabled': {
      '& .MuiStepConnector-line': {
        ...fakeDashedBorder,
        opacity: 0.6,
        backgroundImage: `linear-gradient(90deg, transparent, transparent 50%, #fff 50%, #fff 100%),
        linear-gradient(90deg, ${theme.palette.neutral.lighter}, ${theme.palette.neutral.lighter})`,
      },
    },
  },
  cancelled: {
    '& .MuiTypography-h4': {
      color: theme.palette.primary.dark,
    },
    '&.next-status_disabled': {
      '& .MuiStepConnector-line': {
        opacity: 0.6,
        ...fakeDashedBorder,
        backgroundImage: `linear-gradient(90deg, transparent, transparent 50%, #fff 50%, #fff 100%),
        linear-gradient(90deg, ${theme.palette.neutral.lighter}, ${theme.palette.neutral.lighter})`,
      },
    },
    '& ~ .next-status_disabled': {
      opacity: 0.6,
      '& .MuiStepConnector-line': {
        ...fakeDashedBorder,
        backgroundImage: `linear-gradient(90deg, transparent, transparent 50%, #fff 50%, #fff 100%),
        linear-gradient(90deg, ${theme.palette.neutral.lighter}, ${theme.palette.neutral.lighter})`,
      },
      '& .MuiTypography-h4': {
        color: theme.palette.neutral.lighter,
      },
      '& $address': {
        pointerEvents: 'none',
        '& .MuiTypography-root': {
          color: theme.palette.neutral.lighter,
        },
        '& .MuiButtonBase-root': {
          color: theme.palette.neutral.lighter,
        },
        '& .MuiLink-root::after': {
          backgroundColor: theme.palette.neutral.lighter,
        },
      },
      '& $dateWrapper': {
        display: 'none',
      },
    },
  },
  dateWrapper: {
    position: 'absolute',
    top: `-${theme.spacing(15)}`,
    left: `calc(50% - ${theme.spacing(1.25)})`,
    height: theme.spacing(15),
    width: theme.spacing(20),
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
  },
  shippingDateLabel: {
    marginBottom: 1,
    color: theme.palette.neutral.main,
    whiteSpace: 'nowrap',
  },
  shippingDate: {
    color: theme.palette.neutral.black,
  },
  addressWrapper: { marginTop: theme.spacing(2.5) },
  address: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.5),
    paddingTop: theme.spacing(1.5),
  },
  chip: {
    marginTop: theme.spacing(2),
    color: theme.palette.yellow.darkest,
    backgroundColor: theme.palette.yellow.lighter,
  },
}))

export default useStyles
